/**
 * An enum to define what type of logging event to log in custom-made message box (0 - Info, 1 - Warning, 2 - Error)
 */
enum LogType {
  Info = 0,
  Warning = 1,
  Error = 2
}

/**
 * The type of fortification event that has occurred.
 */
enum FortificationEventType {
  Unknown,
  /** Occurs when a service call succeeds but returns surprising data (e.g. 200 with malformed response) */
  UnexpectedServiceResponse,
  /** Occurs when a service request fails (e.g. non-200) */
  ServiceRequestFailed,
  /** Occurs when an invalid fortification code is submitted to the fortification service. */
  InvalidCodeSubmitted,
  /** Occurs when an invalid visit id is submitted to the fortification service. */
  InvalidAuthenticatedVisit
}

enum CodeRedemptionStatus {
  InvalidCodeSubmitted,
  ExpiredCode,
  SuccessfulRedemption
}

/** This enumeration captures all high level states of eligibility that an action may have in reference to the currently bound ActionContext. */
enum ActionEligibility {
  /** The action is eligible to be invoked. */
  Default,
  /** The action is not applicable to the current action context. */
  NotApplicable,
  /** The action is not allowed (e.g. lack of permissions) to be run on the current action context. */
  NotAllowed,
  /** It is not yet known if the action is eligible to be invoked. This value is expected to be updated asynchronously. */
  NotYetKnown
}

/** The type of user experience expected for action completion. */
enum ActionUXType {
  /** No user experience needed, traditionally used for background tasks. */
  None,

  /** The user experience is a piece of content hosted at an offered route by the action host. */
  Routed,

  /** the user experience is a piece of content hosted in a modal dialog. Note that modals cannot be launched from other modals. */
  Modal
}

/**
 * Types of customer ids compatible with the fortification service.
 */
enum CustomerIdType {
  /** Decimal based PUID */
  Puid,
  /** Hardware service id */
  Hardware,
  /** Email used as the customer identifier */
  Email,
  /** Metis Service request id */
  ServiceRequest,
  /** Metro Id */
  MetroId,
  /** SkypeId -- currently the skype username is the SkypeId, and "user|||password"" credentials are needed in the 'AgentSkypeCredentials' header for this to work. */
  SkypeId,
  /**Email contact from Jarvis CPM data source */
  CpmEmail
}

export class SdServicesSharedEnums {
  public readonly logType: any;
  public readonly fortificationEventType: any;
  public readonly codeRedemptionStatus: any;
  public readonly actionEligibility: any;
  public readonly actionUXType: any;
  public readonly customerIdType: any;

  constructor() {
    this.logType = LogType;
    this.fortificationEventType = FortificationEventType;
    this.codeRedemptionStatus = CodeRedemptionStatus;
    this.actionEligibility = ActionEligibility;
    this.actionUXType = ActionUXType;
    this.customerIdType = CustomerIdType;
  }
}
